import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility per combinare classi CSS con supporto Tailwind.
 * Unisce clsx per condizioni e twMerge per risolvere conflitti Tailwind.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
